import { configureStore } from "@reduxjs/toolkit";
import { createCategoryReducer } from "./coupon/CreateCategoryRTK";
import { deleteCategoryReducer } from "./coupon/DeleteCategoryRTK";
import { getCategoryReducer } from "./coupon/GetCategoryRTK";
import { linkCategoryReducer } from "./coupon/LinkCategoryRTk";
import { qwickSilverCouponReducer } from "./coupon/qwickSilverRTK";
import { unlinkCategoryReducer } from "./coupon/unLinkCategoryRTK";
import { updateCategoryReducer } from "./coupon/updateCategoryRTK";
import { getQwikVoucehersReducer } from "./quick-silver/getQuickSilverCoupons";

export const store = configureStore({
  reducer: {
    qwickSilver: qwickSilverCouponReducer,
    getCategory: getCategoryReducer,
    createCategory: createCategoryReducer,
    linkCategory: linkCategoryReducer,
    deleteCategory: deleteCategoryReducer,
    updateCategory: updateCategoryReducer,
    unlinkCategory: unlinkCategoryReducer,

    // qiwk silver
    getQwikVoucehers: getQwikVoucehersReducer,
  },
});
